import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import Checkbox from "../Checkbox";
import { FormContext, FormError } from "./";
import Group from "../Group";
import Radio from "../Radio";
import Switch from "../Switch";
import { Text } from "../Text";

var FormField = function FormField(props) {
  var getTextProps = function getTextProps(size) {
    return {
      lineHeight: size === 'jumbo' ? 24 : 20,
      size: size === 'jumbo' ? 16 : 14
    };
  };

  var className = props.className,
      children = props.children,
      description = props.description,
      error = props.error,
      remaining = _objectWithoutProperties(props, ["className", "children", "description", "error"]);

  var classes = classNames('FormField', className);
  return /*#__PURE__*/React.createElement(FormContext.Consumer, null, function (_ref) {
    var size = _ref.size;
    var renderableChildren = React.Children.toArray(children);
    var inputAlignment;
    React.Children.forEach(renderableChildren, function (child) {
      var childMatch = child.type === Checkbox || child.type === Radio || child.type === Switch;

      if (childMatch && size === 'small') {
        inputAlignment = {
          vertical: 2
        };
      }

      if (childMatch) {
        inputAlignment = {
          vertical: 4
        };
      }
    });
    var infoAlignment;
    React.Children.forEach(renderableChildren, function (child) {
      var childMatch = child.type === Checkbox || child.type === Radio || child.type === Switch;

      if (childMatch && child.props.label) {
        infoAlignment = {
          left: 24
        };
      } else if (childMatch) {
        infoAlignment = {
          top: 4
        };
      } else {
        infoAlignment = {
          top: 8
        };
      }
    });
    var hasCopy = description || error;
    return /*#__PURE__*/React.createElement("div", _extends({}, remaining, {
      className: classes
    }), /*#__PURE__*/React.createElement(Box, {
      padding: inputAlignment
    }, children), hasCopy && /*#__PURE__*/React.createElement(Group, {
      padding: infoAlignment,
      spacing: 4
    }, description && /*#__PURE__*/React.createElement(Text, _extends({}, getTextProps(size), {
      color: "default"
    }), description), error && /*#__PURE__*/React.createElement(FormError, getTextProps(size), error)));
  });
};

export default FormField;